import type { FormInputType } from '../types'
import FormInputDate from './FormInputDate'
import FormInputEquation from './FormInputEquation'
import FormInputMultiCheckbox from './FormInputMultiCheckbox'
import FormInputMultiSelect from './FormInputMultiSelect'
import FormInputMultiSelectTab from './FormInputMultiSelectTab'
import FormInputNumber from './FormInputNumber'
import FormInputPhone from './FormInputPhone'
import FormInputRadio from './FormInputRadio'
import FormInputRichText from './FormInputRichText'
import FormInputSelect from './FormInputSelect'
import FormInputSelectAsync from './FormInputSelectAsync'
import FormInputSelectTab from './FormInputSelectTab'
import FormInputText from './FormInputText'
import FormInputTextarea from './FormInputTextarea'
import FormInputTimeRange from './FormInputTimeRange'
import FormInputVideo from './FormInputVideo'

const FormInput: React.FC<{
  input: FormInputType
}> = ({ input }) => {
  if (input.Component != null) {
    return <input.Component input={input} />
  }

  // NOTE: Alphabetically sorted
  if (input.type === 'date') {
    return <FormInputDate input={input} />
  }

  if (input.type === 'equation') {
    return <FormInputEquation input={input} />
  }

  if (input.type === 'multi-checkbox') {
    return <FormInputMultiCheckbox input={input} />
  }

  if (input.type === 'multi-select') {
    return <FormInputMultiSelect input={input} />
  }

  if (input.type === 'multi-select-tab') {
    return <FormInputMultiSelectTab input={input} />
  }

  if (input.type === 'number') {
    return <FormInputNumber input={input} />
  }

  if (input.type === 'phone') {
    return <FormInputPhone input={input} />
  }

  if (input.type === 'radio') {
    return <FormInputRadio input={input} />
  }

  if (input.type === 'rich-text') {
    return <FormInputRichText input={input} />
  }

  if (input.type === 'select' || input.type === 'select-group') {
    return <FormInputSelect input={input} />
  }

  if (input.type === 'select-tab') {
    return <FormInputSelectTab input={input} />
  }

  if (input.type === 'select-async') {
    return <FormInputSelectAsync input={input} />
  }

  if (input.type === 'text') {
    return <FormInputText input={input} />
  }

  if (input.type === 'textarea') {
    return <FormInputTextarea input={input} />
  }

  if (input.type === 'time-range') {
    return <FormInputTimeRange input={input} />
  }

  if (input.type === 'video') {
    return <FormInputVideo input={input} />
  }

  input satisfies never

  throw new Error('Unknown input type')
}

export default FormInput
